<template>
  <div class="w-full bg-legal">
    <div class="py-20 px-4 lg:px-24">
      <h1 class="font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28">Legacy <br>Documents</h1>
    </div>
  </div>

  <div class="bg-white">
    <div class="pl-4 lg:pl-20 py-14 font-poppins">
      <div>
        <div class="grid grid-cols-2 lg:grid-cols-4">
          <div class="col-span-1" v-if="legalDocuments.legacy.length > 0">
            <h3 class="text-xl mt-10 mb-5 font-bold">Legacy Critical Information Summaries (formerly Harbour ISP) </h3>
            <p class="mb-5" v-for="legalDocument in legalDocuments.legacy" :key="legalDocument.name"><a :href="legalDocument.url" class="text-black hover:text-black hover:underline transition duration-250" target="_blank">{{legalDocument.name}}</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();
</script>
<style scoped>
.bg-legal {
  background-repeat: no-repeat;
  background-color: transparent;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/legal-bg.png");
  background-position: center center;
  background-size: cover;
  height: 100%;
}
</style>
